const API_URL = process.env.REACT_APP_API_URL;
const fetchConfig = {
  credentials: "include",
  headers: { "Content-Type": "application/json", Accept: "application/json" },
};
// attach auth token if present
{
  const token = localStorage.getItem("token");
  if (token) fetchConfig.headers.Authorization = `Bearer ${token}`;
}

const fetchFeedbacks = async (page, limit) => {
  const response = await fetch(
    `${API_URL}/feedbacks/feedbacks/${page}/${limit}`,
    { ...fetchConfig, method: "GET" }
  );
  return response.json();
};

const fetchCourseReviews = async (page, limit) => {
  const response = await fetch(
    `${API_URL}/feedbacks/course_reviews/${page}/${limit}`,
    { ...fetchConfig, method: "GET" }
  );
  return response.json();
};

const getFeedbackById = async (id) => {
  const response = await fetch(`${API_URL}/feedbacks/feedback/${id}`, {
    ...fetchConfig,
    method: "GET",
  });
  return response.json();
};

const getReviewById = async (id) => {
  const response = await fetch(`${API_URL}/feedbacks/course_review/${id}`, {
    ...fetchConfig,
    method: "GET",
  });
  return response.json();
};

export const fetchFolders = async () => {
  const response = await fetch(`${API_URL}/support/folders`, {
    ...fetchConfig,
    method: "GET",
  });
  return response.json();
};

export const fetchChats = async (
  page = 1,
  limit = 10,
  pending = false,
  folder = "General Inbox"
) => {
  const params = new URLSearchParams({ folder });
  if (pending) params.append("pending", "true");
  const res = await fetch(
    `${API_URL}/support/chats/${page}/${limit}?${params.toString()}`,
    { ...fetchConfig, method: "GET" }
  );
  return res.json();
};

export const getChatById = async (id) => {
  const response = await fetch(`${API_URL}/support/chat/${id}`, {
    ...fetchConfig,
    method: "GET",
  });
  return response.json();
};

export const createFolder = async (name) => {
  const res = await fetch(`${API_URL}/support/folders`, {
    ...fetchConfig,
    method: "POST",
    body: JSON.stringify({ name }),
  });
  return res.json();
};

export const renameFolder = async (oldName, newName) => {
  const res = await fetch(
    `${API_URL}/support/folders/${encodeURIComponent(oldName)}`,
    {
      ...fetchConfig,
      method: "PUT",
      body: JSON.stringify({ new_name: newName }),
    }
  );
  return res.json();
};

export const deleteFolder = async (name) => {
  const res = await fetch(
    `${API_URL}/support/folders/${encodeURIComponent(name)}`,
    {
      ...fetchConfig,
      method: "DELETE",
    }
  );
  return res.json();
};

export const updateChatFolder = async (collection, id, folderName) => {
  const res = await fetch(
    `${API_URL}/support/update_folder/${collection}/${id}/${encodeURIComponent(
      folderName
    )}`,
    {
      ...fetchConfig,
      method: "PUT",
    }
  );
  return res.json();
};

export { fetchFeedbacks, fetchCourseReviews, getFeedbackById, getReviewById };
